import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    FETCH_PAYMENT_METHODS_V2_SUCCESS,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_SUCCESS,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, get, update, push } from "firebase/database";

export const fetchPaymentMethods = () => (dispatch) => {
   
    const {
        config
    } = firebase;
 
    dispatch({
        type: FETCH_PAYMENT_METHODS,
        payload: null,
    });
    
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/get_providers`;
    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => response.json())
        .then((responseJson) => {
            if (responseJson.length > 0) {
                dispatch({
                    type: FETCH_PAYMENT_METHODS_SUCCESS,
                    payload: responseJson,
                });
            }else{
                dispatch({
                    type: FETCH_PAYMENT_METHODS_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.provider_fetch_error + ": " + error.toString(),
            });
        });
};

export const clearMessage = () => (dispatch) => {
    dispatch({
        type: CLEAR_PAYMENT_MESSAGES,
        payload: null,
    });    
};


export const addToWallet = (uid, amount, description = 'Admin Credit') => async (dispatch) => {
    const { config } = firebase;

    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    try {
        const settings = store.getState().settingsdata.settings;
        let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
        let url = `${host}/add_to_wallet`;
        
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                uid: uid,
                amount: parseFloat(amount),
                description: description,
                transaction_id: new Date().getTime().toString()
            })
        });

        const responseJson = await response.json();
        
        if (responseJson.success) {
            dispatch({
                type: UPDATE_WALLET_BALANCE_SUCCESS,
                payload: null
            });
            return { success: true };
        } else {
            dispatch({
                type: UPDATE_WALLET_BALANCE_FAILED,
                payload: responseJson.error || 'Unknown error occurred',
            });
            return { success: false, error: responseJson.error || 'Unknown error occurred' };
        }
        
    } catch (error) {
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: error.message || 'Network error occurred',
        });
        return { success: false, error: error.message || 'Network error occurred' };
    }
};


export const withdrawBalance = (profile, amount) => async (dispatch) => {

    const {
        withdrawRef,
    } = firebase;
    
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    push(withdrawRef, {
        uid : profile.uid,
        name : profile.firstName +  ' ' + profile.lastName,
        amount : parseFloat(amount),
        date : new Date().getTime(),
        bankName : profile.bankName? profile.bankName : '',
        bankCode : profile.bankCode? profile.bankCode : '',
        bankAccount : profile.bankAccount? profile.bankAccount : '',
        usertype : profile.usertype || 'customer',
        isAgent : profile.usertype === 'agent',
        processed:false
    });
       
};

/**
 * Providers for the signed-in user, plus the amounts their country can move.
 *
 * get_providers_v2 answers for the CALLER — it reads the profile behind the ID
 * token — where get_providers answers for nobody in particular. That is what
 * makes it correct across an account switch: the old endpoint's reply did not
 * depend on who was signed in, so a second account kept the first one's list.
 *
 * It also returns the country's pawaPay envelopes (depositLimits/payoutLimits)
 * so the amount screens can rule out an impossible amount before the user
 * reaches a gateway. payoutLimits is already grossed up for this user's
 * withdrawal commission; depositLimits is not, because deposits are free.
 * See functions/common/countryLimits.js.
 *
 * Called directly on cloudfunctions.net rather than through a hosting rewrite:
 * there is no /get_providers_v2 rewrite, and a missing one does not fail, it
 * silently returns the SPA's index.html and leaves the picker empty.
 */
export const fetchPaymentMethodsV2 = () => async (dispatch) => {
    const { auth, config } = firebase;

    dispatch({
        type: FETCH_PAYMENT_METHODS,
        payload: null,
    });

    // errorCode is what the screens branch on (see PAYMENT_UNAVAILABLE_CAUSE
    // in mobile-app/src/common/paymentAvailability.js); payload stays a
    // human-readable message.
    const failed = (reason) => {
        const lang = store.getState().languagedata.defaultLanguage;
        dispatch({
            type: FETCH_PAYMENT_METHODS_FAILED,
            payload: (lang && lang.payment_fetch_failed) || reason,
            errorCode: "FETCH_FAILED",
        });
    };

    try {
        const user = auth && auth.currentUser;
        if (!user) {
            failed("NOT_SIGNED_IN");
            return;
        }
        const token = await user.getIdToken();
        const url = `https://us-central1-${config.projectId}.cloudfunctions.net/get_providers_v2`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const json = await response.json();

        if (json.error) {
            console.log("fetchPaymentMethodsV2: get_providers_v2 returned error code:", json.error);
        }

        // A resolution error still carries providers: [] and is a real answer,
        // not a transport failure - the screens explain it with the country
        // message rather than the generic "couldn't load" one.
        dispatch({
            type: FETCH_PAYMENT_METHODS_V2_SUCCESS,
            payload: {
                providers: Array.isArray(json.providers) ? json.providers : [],
                country: json.country || null,
                depositLimits: json.depositLimits || null,
                payoutLimits: json.payoutLimits || null,
                error: json.error || null,
                // Which account this list belongs to, so a screen can ignore
                // a list fetched for the previously signed-in user.
                uid: user.uid,
            },
        });
    } catch (error) {
        failed(error.message);
    }
};
